"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollableBox = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const CustomBoxDynamicHeights = (0, _mui.styled)(_mui.Box, {
  shouldForwardProp: propName => propName !== 'dynamicHeight'
})(({
  theme,
  dynamicHeight
}) => ({
  position: 'fixed',
  top: 'var(--top-nav-height)',
  right: 0,
  padding: 0,
  height: '100%',
  maxHeight: 'calc(100% - var(--top-nav-height))',
  maxWidth: '100%',
  zIndex: theme.zIndex.appBar,
  overflowX: 'hidden',
  overflowY: 'auto',
  backgroundColor: theme.palette.grey[50],
  border: '1px solid',
  borderColor: theme.palette.grey[100],
  boxShadow: _mui.SHADOW_LEVEL2,
  boxSizing: 'border-box',
  overscrollBehavior: 'contain',
  MsOverflowStyle: '-ms-autohiding-scrollbar',
  WebkitOverflowScrolling: 'touch',
  [theme.breakpoints.up('sm')]: {
    boxShadow: `0 3px 8px 0 ${theme.palette.grey[200]}`,
    scrollbarWidth: 'thin',
    scrollbarColor: `${theme.palette.grey[300]} transparent`,
    '&::-webkit-scrollbar': {
      width: 6,
      height: 6
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 3,
      backgroundColor: theme.palette.grey[300]
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: theme.palette.grey[400]
    },
    '&::-webkit-scrollbar-thumb:active': {
      backgroundColor: theme.palette.grey.A400
    },
    '&::-webkit-scrollbar-thumb:vertical': {
      minHeight: 10
    },
    '&::-webkit-scrollbar-thumb:horizontal': {
      minWidth: 10
    }
  },
  ...(dynamicHeight && {
    [theme.breakpoints.up('sm')]: {
      height: 'auto'
    }
  })
}));
const ScrollableBox = ({
  children,
  dynamicHeight
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomBoxDynamicHeights, {
  dynamicHeight: dynamicHeight,
  children: children
});
exports.ScrollableBox = ScrollableBox;
